import { Item } from "@/components/form/Dropdown";
import { Button } from "@/components/ui/button";
import { DataTableFacetedFilter } from "@/components/ui/data-table-faceted-filter";
import { Input } from "@/components/ui/input";
import { useCurrentUser } from "@/context/UserContext";
import { Cross2Icon } from "@radix-ui/react-icons";
import { Table } from "@tanstack/react-table";
import { Search } from "lucide-react";
import { useEffect, useState } from "react";

interface PayslipToolbarProps<TData> {
  table: Table<TData>;
}
export function PayslipToolbar<TData>({ table }: PayslipToolbarProps<TData>) {
  const { currentUser } = useCurrentUser();
  const isFiltered = table.getState().columnFilters.length > 0;

  const [yearOptions, setYearOptions] = useState<Item[]>([]);

  useEffect(() => {
    if (!currentUser || !currentUser.hireDate) return;
    // get years from currentuser.hiredate year till now
    const currentYear = new Date().getFullYear();
    const hireYear = new Date(currentUser.hireDate).getFullYear();
    const years = Array.from(
      { length: currentYear - hireYear + 1 },
      (_, i) => hireYear + i
    );
    setYearOptions(
      years.map((year) => ({
        label: year.toString(),
        value: year.toString(),
      }))
    );
  }, [currentUser]);

  return (
    <div className="flex flex-wrap items-center justify-between h-[60px] ml-1 mb-2">
      <div className="flex flex-1 flex-wrap items-center gap-2 h-full w-full">
        {table.getColumn("year") && (
          <DataTableFacetedFilter
            column={table.getColumn("year")}
            title="Year"
            options={yearOptions}
          />
        )}
        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <Cross2Icon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
